import { render, staticRenderFns } from "./OverlaySpinner.vue?vue&type=template&id=04179563&scoped=true&"
import script from "./OverlaySpinner.vue?vue&type=script&lang=js&"
export * from "./OverlaySpinner.vue?vue&type=script&lang=js&"
import style0 from "./OverlaySpinner.vue?vue&type=style&index=0&id=04179563&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04179563",
  null
  
)

export default component.exports